import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-unavailable-message',
  standalone: true,
  imports: [CommonModule, MatButtonModule, RouterLink],
  templateUrl: './unavailable-message.component.html',
  styleUrls: ['./unavailable-message.component.scss'],
})
export class UnavailableMessageComponent {}
